import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import wechatSDK from '@/utils/wechatSDK'
import {
  _FlutterShowReturn
} from '@/utils/flutterPlugin'
import {
  authNeed
} from '@/utils/auth'
import * as types from '@/store/mutation-types'
import {
  setDefaultCity
} from '@/utils/init'
import {
  getUrlSpecifiedParam
} from '@/utils/tool'
import {
  defaultMenu
} from '@/config/common'
import customerService from '@/utils/customerService'
import routes from './modules/index'
import comefromConfig from '@/utils/comefromConfig'

// import $storage from '@/utils/storage'

// 获取原型对象上的push函数
const originalReplace = VueRouter.prototype.replace
// 修改原型对象中的push方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}
// 解决vue-router路由重定向报错
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.documentElement.scrollTop || document.body.scrollTop
      }

      return {
        x: 0,
        y: to.meta.savedPosition || 0
      }
    }
  },
  routes
})

// 在路由完成初始化
router.onReady(() => {
  // 获取其他项目的城市定位
  const city = localStorage.getItem('myLocationInfo') ? JSON.parse(localStorage.getItem('myLocationInfo')) : null
  if (city) {
    setDefaultCity(city.city_name, city.area_code)
  }

  // 如果url上带了城市名那就默认选中
  if (getUrlSpecifiedParam('city_name')) {
    setDefaultCity(decodeURIComponent(getUrlSpecifiedParam('city_name')))
  }
})

router.beforeEach((to, from, next) => {
  // document.title = store.state.thirdParty === '10000002' ? '华润e润保' : to.meta.title || (store.state.channel === '004_01_0010_0001_01' ? '莲心医生' : '健康管理平台')
  // if (sessionStorage.getItem('comefrom') === 'pocketInfirmarySystem') {
  if (['pocketInfirmarySystem','kangarooPhysicalSystem'].includes(sessionStorage.getItem('comefrom'))) {
    document.title = comefromConfig[sessionStorage.getItem('comefrom')].windowTitle || ''
  } else {
    document.title = store.state.thirdParty === '10000002' ? '华润e润保' : to.meta.title || (store.state.channel === '004_01_0010_0001_01' ? '莲心医生' : '健康管理平台')
  }
  store.commit(types.SET_LOADING, false)
  // 添加百度统计
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  // keep-alive
  if ((to.meta || {}).keepAlive) {
    // 判断是否有父级路由，将父级路由也加入缓存
    // 没有做父级delete的逻辑，可能有bug~
    if (to.matched.length > 1) {
      const list = to.matched.slice(0, to.matched.length - 1)
      list.forEach((item) => {
        store.commit(types.SET_KEEPALIVEPAGES, item.name)
      })
    }
    store.commit(types.SET_KEEPALIVEPAGES, to.name)
  }
  // titleBar
  if (to.meta.titleBar) {
    if (to.meta.titleBar.hasMenu && !to.meta.titleBar.menu) {
      // 设置默认菜单
      to.meta.titleBar.menu = defaultMenu
    }
    store.commit(types.SET_TITLE_BAR, to.meta.titleBar)
  }
  // store.commit(types.SET_CUR_CITY, {})
  // 授权判断
  if (!store.state.user.authStatus && (to.meta.login || to.meta.auth)) {
    console.log('路由钩子-调用authNeed')
    authNeed({
      route: to,
      next
    })
  } else {
    next()
  }
})

// 分享地址应该分享首页 而并非是页面本身的地址 原因是不是所有的用户都有这些页面
// 不做特意判断了 直接分享首页出去 有需要的可以在数组内追加了 注意：是页面级组件内定义的name 而不是path
const shareHomePage = [
  'is-partner',
  'partner',
  'project-agent',
  'activity-share',
  'vip-qy'
]
router.afterEach((to, from) => {
  const keepAlive = (from.meta || {}).keepAlive
  if (keepAlive && keepAlive.length && keepAlive.indexOf(to.name) === -1) {
    store.commit(types.DELETE_KEEPALIVEPAGES, from.name)
  }

  // 微信分享
  if (shareHomePage.includes(to.name)) {
    wechatSDK({
      link: window.shareHome
    })
  } else if (to.name === 'activity-gifts') {
    // console.log(store.state.user.user.invitation_code)
    wechatSDK({
      title: '注册领取免费福利！',
      desc: '一键完成平台注册，即可免费领取问诊服务及积分权益。',
      link: window.invitationPage + `?invitation_code=${store.state.user.user.invitation_code}`
    })
  } else if (to.meta.wechatShareConfig) {
    // 路由配置定义的微信分享
    const config = to.meta.wechatShareConfig
    wechatSDK({
      title: config.title,
      desc: config.desc,
      imgUrl: config.imgUrl,
      link: location.origin + location.pathname + `#/${config.route}`
    })
  } else if (to.meta.hiddenWeChatShare) {
    // 隐藏微信分享
    wechatSDK({
      hiddenWeChatShare: true
    })
  } else {
    // 默认的全局微信分享，分享首页
    wechatSDK()
  }

  _FlutterShowReturn(to, from)

  // 设置袋鼠客服所需的页面参数
  // setCustomerServiceOptions(to, from)
})

function setCustomerServiceOptions(to, from) {
  let name
  if (to.meta && to.meta.titleBar) {
    name = to.meta.titleBar.title || to.name
  }
  customerService.setOptions({
    page: {
      name: name ? encodeURIComponent(name) : '',
      url: window.location.href
    }
  })
}

export default router
